import React from "react";
import { Trophy } from "lucide-react";

import { canalPorChave } from "@/components/canais/canais";
import IconeCanal from "@/components/canais/IconeCanal";

import { formatCurrency, formatPct } from "../lib/formato";

// Quem mais deixa dinheiro no caixa: lucro de cada módulo, do maior ao menor.
// Módulo com prejuízo aparece em vermelho, com a barra para o outro lado.
export default function RankingLucro({ modulos }) {
  const ativos = modulos.filter((m) => m.pedidos || m.despesas).sort((a, b) => b.lucro - a.lucro);
  if (ativos.length < 2) return null;
  const max = Math.max(...ativos.map((m) => Math.abs(m.lucro)), 0.01);
  return (
    <div className="bg-card rounded-2xl border p-5 sm:p-6" data-e2e="ranking-lucro">
      <div className="flex items-center gap-2 mb-4">
        <Trophy className="w-5 h-5 text-amber-500" />
        <h2 className="text-lg font-bold">Lucro por módulo</h2>
        <span className="text-xs text-muted-foreground ml-auto">vendas − CMV − despesas atribuídas</span>
      </div>
      <div className="space-y-3">
        {ativos.map((m) => {
          const canal = canalPorChave(m.key);
          const largura = Math.max(2, (Math.abs(m.lucro) / max) * 100);
          const negativo = m.lucro < 0;
          return (
            <div key={m.key} className="flex items-center gap-3">
              <div className="flex items-center gap-2 w-32 shrink-0 min-w-0">
                <IconeCanal canal={canal} className="w-4 h-4 shrink-0" />
                <span className="text-sm font-medium truncate">{canal.nome}</span>
              </div>
              <div className="flex-1 h-6 bg-muted/40 rounded-md overflow-hidden">
                <div className="h-full rounded-md transition-all" style={{ width: `${largura}%`, backgroundColor: negativo ? "#ef4444" : canal.hex }} />
              </div>
              <div className="w-40 shrink-0 text-right">
                <span className={`font-mono font-bold tabular-nums text-sm ${negativo ? "text-red-600 dark:text-red-400" : ""}`}>{formatCurrency(m.lucro)}</span>
                <span className="ml-2 text-[11px] text-muted-foreground tabular-nums">{m.margem_pct == null ? "—" : formatPct(m.margem_pct)}</span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
